// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  enableDebug: true,

  numero_WhatsApp: "",
  numero_telefono: "tel:+390816040957",

  //text per personalizzare i messaggi
  canShowPagamentoRate: false,
  textShowPagamentoRate: "in comode <strong>2 rate</strong>",

  canShowElencoDate: true,

  /*
  urlWeb: 'http://localhost/',
  urlMaterialeDidattico: 'http://localhost/assets/media/materiale-didattico/1/',
  urlImageCorso: 'http://localhost/assets/media/corso/',
  urlImageCorsoHD: 'http://localhost/assets/media/corso/hd/',
  urlImageVideoCorso: 'http://localhost/assets/media/corso/video/',
  web_api_url_base: 'http://localhost/api/',

  urlStampa: 'http://localhost/stampe/',

  urlAttestati: 'http://localhost/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'http://localhost/pages/certificate/',
  urlImagePartners: 'http://localhost/assets/media/partners/',
  urlImageMedia: 'http://localhost/assets/media/',
  */

  urlWeb: 'https://discentya.netconsrl.cloud/',
  urlMaterialeDidattico: 'https://discentya.netconsrl.cloud/assets/media/materiale-didattico/1/',
  urlImageCorso: 'https://discentya.netconsrl.cloud/assets/media/corso/',
  urlImageCorsoHD: 'https://discentya.netconsrl.cloud/assets/media/corso/hd/',
  urlImageVideoCorso: 'https://discentya.netconsrl.cloud/assets/media/corso/video/',
  web_api_url_base: 'https://discentya.netconsrl.cloud/api/',

  urlStampa: 'https://discentya.netconsrl.cloud/stampe/',

  urlAttestati: 'https://discentya.netconsrl.cloud/assets/media/certificate/corsisti/',
  urlAttestatiDaCreare: 'https://discentya.netconsrl.cloud/pages/certificate/',
  urlImagePartners: 'https://discentya.netconsrl.cloud/assets/media/partners/',
  urlImageMedia: 'http://discentya.netconsrl.cloud/assets/media/',

};

